import { render } from "./MenuTab.vue?vue&type=template&id=f83f9e12"
import script from "./MenuTab.vue?vue&type=script&lang=js"
export * from "./MenuTab.vue?vue&type=script&lang=js"

import exportComponent from "F:\\App-themes\\clickon\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__